import React from 'react';
import { Link } from 'react-router-dom';

const ChoseArea = () => {
    return (
        <>
            <section className="tp-choose-area position-relative pt-120 pb-90">
            <div className="tp-choose-yellow-bg"></div>
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-xl-6 col-lg-8">
                        <div className="tp-choose z-index">
                            <div className="tp-section-title-wrapper mb-105 wow fadeInUp" data-wow-delay=".2s">
                                <h5 className="tp-section-subtitle common-yellow-shape common-white-shape section__sm__title">Pourquoi nous choisir</h5>
                                <h4 className="tp-section-title">Un service de nettoyage de maison expert auquel vous pouvez faire confiance</h4>
                            </div>
                            <div className="tp-choose-img mb-40 z-index d-block d-xl-none">
                                <img src="assets/img/about/choose-img-1.jpg" alt="img not found"/>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="tp-choose-timeline ml-15 mb-30">
                                        <div className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp" data-wow-delay=".4s">
                                            <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                                              <Link to="/servicesDetails">Chaque client <br/>est spécial</Link>
                                             </h4>
                                            <p>"Chez nous, chaque espace a son histoire – Votre univers mérite un nettoyage sur mesure" </p>
                                        </div>
                                        <div className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp" data-wow-delay=".6s">
                                            <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color">
                                                <Link to="/servicesDetails">Assistance clientèle</Link>
                                                </h4>
                                            <p>Assistance 360° – Réactive, Humaine, Sans Limites </p>
                                        </div>
                                        <div className="tp-choose-timeline-single pl-35 wow fadeInUp" data-wow-delay=".8s">
                                            <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color"><Link to="/servicesDetails">Bénéficiez de réductions <br/>sur les frais</Link></h4>
                                            <p>Votre Propreté, Notre Priorité – Bénéficiez de Réductions Exclusives !</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="tp-choose-timeline ml-15 mb-30">
                                        <div className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp" data-wow-delay="1s">
                                            <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color"><Link to="/servicesDetails">Contactez nous</Link></h4>
                                            <p>Votre propreté sur mesure commence ici ✨ </p>
                                        </div>
                                        <div className="tp-choose-timeline-single mb-55 pl-35 wow fadeInUp" data-wow-delay="1.2s">
                                            <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color"><Link to="/servicesDetails">Informations pour tous les<br/>Services</Link></h4>
                                            <p>Des solutions sur mesure pour chaque espace, avec une qualité constante ✨ </p>
                                        </div>
                                        <div className="tp-choose-timeline-single pl-35 wow fadeInUp" data-wow-delay="1.4s">
                                            <h4 className="tp-choose-timeline-single-title mb-15 hover-theme-color"><Link to="/servicesDetails">Nous offrons une assistance 24h/24 et 7j/7</Link></h4>
                                            <p>Quand vous avez besoin de nous, nous sommes là - jour et nuit, week-end et jours fériés ✨</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-12">
                        <div className="tp-choose-img mb-30 z-index d-none d-xl-block wow fadeInUp" data-wow-delay=".6s">
                            <img src="assets/img/about/choose-img-1.jpg" alt="img not found"/>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
        </>
    );
};

export default ChoseArea;